import React, { Component } from "react";
import Loading from "../../../components/Loading";
import Form from "./Form";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { SubmissionError } from "redux-form";
import * as sessionService from "../../../services/session";
import ApiConfig from "../../../constants/ApiConfig";

import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Badge,
  DropdownItem,
  Button,
  Row,
  Col,
} from "reactstrap";

import * as pageService from "../../../services/page";

class PageView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      loaded: false,
      id: this.props.match.params.id,
    };

    this.load = this.load.bind(this);
    this.edit = this.edit.bind(this);
  }

  componentWillMount() {
    this.load(this.props);
  }

  /*static getDerivedStateFromProps(props, state) {
        return null
    }*/

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.match.params.id !== nextProps.match.params.id)
      this.load(nextProps);
  }

  load(props) {
    if (props.match.params.id) {
      pageService.view(props.match.params.id).then((data) => {
        this.setState(
          {
            data,
            loaded: true,
          },
          () => {},
        );
      });
    } else {
      this.setState({ loaded: true }, () => {});
    }

    console.log("normalement loaded", props.match.params.id);
  }

  edit(id) {
    this.props.history.push(`/pages/edit/${id}`);
  }

  render() {
    const { history, match } = this.props;
    const { data, loading } = this.state;

    if (!this.state.loaded) return <Loading />;
    else
      return (
        <div className="animated fadeIn">
          {sessionService.testRole("ROLE_ADMIN") && (
            <Button
              color={"success"}
              className={"pull-right"}
              onClick={() => this.edit(this.state.data.id)}
            >
              <i className={"fa fa-edit"} /> Editer
            </Button>
          )}
          <h1>{this.state.data.title}</h1>

          <Card>
            <CardBody>
              {this.state.data.contents.map((content, index) => {
                switch (content.type) {
                  case "title":
                    return <h2 key={index}>{content.title}</h2>;
                    break;
                  case "text":
                    return (
                      <div
                        key={index}
                        dangerouslySetInnerHTML={{ __html: content.text }}
                      />
                    );
                    break;
                  case "textImg":
                    return (
                      <div
                        key={index}
                        style={{ textAlign: "center", margin: "0 0 25px 0" }}
                      >
                        <Row>
                          <Col>
                            <p>
                              {content.media &&
                              content.media.type == "document" ? (
                                <a
                                  href={`${ApiConfig.assetUrl}${
                                    content.media.url
                                  }`}
                                  target="_blank"
                                  download={content.media.title}
                                  style={{ maxWidth: "100%", color: "red" }}
                                >
                                  {content.title}
                                </a>
                              ) : (
                                <span>{content.title}</span>
                              )}
                            </p>
                            <p style={{ whiteSpace: "pre-wrap" }}>
                              {content.text}
                            </p>

                            {content.url && (
                              <a target="_blank" href={`${content.url}`}>
                                {content.url}
                              </a>
                            )}
                          </Col>

                          {content.media && content.media.type !== "document" && (
                            <Col>
                              {content.media &&
                                content.media.type == "document" && (
                                  <a
                                    href={`${ApiConfig.assetUrl}${
                                      content.media.url
                                    }`}
                                    target="_blank"
                                    download={content.media.title}
                                    style={{ maxWidth: "100%", color: "red" }}
                                  >
                                    <i className="fa fa-file-pdf-o fa-2x" />
                                  </a>
                                )}

                              {content.media && content.media.type == "image" && (
                                <div
                                  style={{
                                    textAlign: "center",
                                    margin: "0 0 15px 0",
                                  }}
                                >
                                  <img
                                    src={
                                      content.media &&
                                      `${ApiConfig.assetUrl}/${
                                        content.media.url
                                      }`
                                    }
                                    style={{ maxWidth: "100%" }}
                                  />
                                </div>
                              )}
                            </Col>
                          )}
                        </Row>
                      </div>
                    );
                    break;
                  case "img":
                    if (content.media && content.media.type == "document") {
                      return (
                        <div
                          key={index}
                          style={{ textAlign: "center", margin: "0 0 25px 0" }}
                        >
                          <a
                            href={`${ApiConfig.assetUrl}${content.media.url}`}
                            target="_blank"
                            download={content.media.title}
                            style={{ maxWidth: "100%", color: "red" }}
                          >
                            <i className="fa fa-file-pdf-o fa-2x" />
                          </a>
                        </div>
                      );
                    }

                    if (content.media && content.media.type == "image") {
                      return (
                        <div
                          key={index}
                          style={{ textAlign: "center", margin: "0 0 25px 0" }}
                        >
                          <img
                            src={
                              content.media &&
                              `${ApiConfig.assetUrl}${content.media.url}`
                            }
                            style={{ maxWidth: "100%" }}
                          />
                        </div>
                      );
                    }
                    break;
                }
              })}
            </CardBody>
          </Card>
        </div>
      );
  }
}

export default PageView;



// WEBPACK FOOTER //
// ./src/views/Cms/Pages/View.js